export class TipoComunidad {
  constructor(
    public readonly Id: number,
    public readonly Codigo: string | null,
    public readonly Nombre: string | null,
    public TipoComunidadEnum: number | null,
    public TipoComunidadEnumNombre: number | null,
    public  Activo: boolean
  ) {}
}

export class TipoComunidadEnum {
  constructor(
    public readonly Id: number,
    public readonly Nombre: string
  ) {}
}

export class SearchTipoComunidadRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    public readonly TipoComunidadEnum: number | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}

export class SaveTipoComunidadDto {
  constructor(
    public Nombre: string | null,
    public Codigo: string | null,
    public Activo: boolean,
    public TipoComunidadEnum: number | null
  ) {}
}

export class SearchTipoComunidadResponse {
  constructor(
    public readonly count: number,
    public readonly result: TipoComunidad[]
  ) {}
}
